import React from 'react'
import { ButtonWrapper, Roll } from './ElementsStyles'

export default function OperationButtons() {
  return (
    <ButtonWrapper flexDirection={'column'} margin={'0 0 0 5px'}>
      <Roll width={'22px'} height={'22px'} lowercase fontSize={'10px'}>
        1/2
      </Roll>
      <Roll under width={'22px'} height={'22px'} lowercase fontSize={'10px'}>
        2x
      </Roll>
    </ButtonWrapper>
  )
}
